import {webClient} from "../../../config/axios";

export const deleteNotificationRequest = (list) => {
    let deletePromises = []
    list.forEach((notificationId)=>{
        deletePromises.push(webClient.delete(`/notifications/${notificationId}`))
    })
    return deletePromises;
};